import _extends from "@babel/runtime/helpers/extends";
import { ErrorMessage, Field, HelperMessage } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import React from 'react';
export const INVALID_EXTERNAL_URL_MESSAGE = 'Must be a valid URL';

const validateUrl = (value, {
  hasSolutionPartnerBenefit
}) => {
  if (hasSolutionPartnerBenefit && value === '') {
    return INVALID_EXTERNAL_URL_MESSAGE;
  }
};

const SupportBaseUrlInput = ({
  baseUrl
}) => {
  return /*#__PURE__*/React.createElement(Field, {
    label: "Atlassian Support Tools URL",
    name: "supportBaseUrl",
    defaultValue: baseUrl,
    validate: validateUrl
  }, ({
    fieldProps,
    error
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Textfield, _extends({}, fieldProps, {
    type: "url"
  })), error ? /*#__PURE__*/React.createElement(ErrorMessage, null, error) : null, /*#__PURE__*/React.createElement(HelperMessage, null, "The base URL for the partner's Atlassian Support Tools provided by the free license program for partners.")));
};

export default SupportBaseUrlInput;